import React, { useState, useEffect } from 'react';

/**
 * PC_MTc_04 getPolicyData gets imported from api.js file
 */
import { getPolicyData } from '../service/api';

import '../components/css/Dashboard-styles.css';

const PolicyData = () => {

    /**
 * PC_PCc_02
 * The data state variable is created for storing the response data
 */

    const [data, setData] = useState([]);


    /**
* PC_PCc_03
* Use Efffect method is called 
*/


    useEffect(() => {
        fetchApi();
    }, []);


    /**
* PC_Pcc_06
* The fetchApi function in the useEffects gets invoked which inturn call the getPolicyData() function with respective parameters
*/

    const fetchApi = async () => {
        const resp = await getPolicyData([]);

        if (resp?.data?.ResponseData?.length) setData(resp.data.ResponseData);
    };


    /**
* PC_PCc_10
* The response data gets stored in the data variable and mapped to the respective divs
*/

    const policyBody = () => {
        try {
            return data.map((datum, i) => {
                return (
                    <a
                        target="_blank"
                        href={datum.policy_attachment_url}
                        className="semibold-text font-12 dashboard-policy-color text-decoration-none ms-3 mt-3 d-block"
                    >
                        {datum.name}{' '}
                        <span>
                            <img src="/Images/re-direct link.png" className="dashboard-view-arrow-size" />
                        </span>
                    </a>
                );
            });
        } catch (err) {

        }
    };

    return (
        <>
            <div className="rounded-5 dashboard-container-background dashboard-policy-card-size">
                <div className="d-flex justify-content-between">
                    <h1 className="tt-bold font-15 pt-3 ps-3">Policies</h1>
                    <a href="/policy" className="semibold-text font-12 pe-3 text-decoration-none mt-3">
                        View all
                        <span>
                            <img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" />
                        </span>
                    </a>
                </div>
                {policyBody()}
            </div>
        </>
    );
};

export default PolicyData;
